import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { theme as antdTheme } from 'antd';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
const ConfigEmotion = ({ theme, children }) => {
    const { token } = antdTheme.useToken();
    const emotionTheme = useMemo(() => {
        return Object.assign(Object.assign({}, theme), { antd: token });
    }, [theme, token]);
    return _jsx(EmotionThemeProvider, Object.assign({ theme: emotionTheme }, { children: children }));
};
export default ConfigEmotion;
